import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const EditIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.82 5.38C16.8 4.4 18.38 4.4 19.38 5.38C20.36 6.36 20.36 7.96 19.38 8.94L8.36 19.96L3.9 20.86L4.8 16.4L15.82 5.38ZM15.72 7.74L6.06 17.4L5.72 19.04L7.36 18.7L17.02 9.04L15.72 7.74Z" />
    </SvgIcon>
  );
});
